import { QUESTION_ANSWER_SLIDE_COMPONENT } from '../quiz-component-types';

const RISK_QUESTION_IDS = [10001, 10002];

const QUIZ_RISK_SLIDES = [
    {
        id: 10001,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'If you spot a charge you don’t recognize on your bank statement, what is your first step?',
            answers: [
                {
                    text: 'Contact the company directly to ask about it or request a refund',
                    id: 1,
                    score: 1
                },
                {
                    text: 'Call my bank immediately to report it and replace my card',
                    id: 2,
                    score: 0
                },
                {
                    text: 'Ask a trusted family member or friend for help',
                    id: 3,
                    score: 1
                },
                {
                    text: 'Ignore it if the amount is small enough',
                    id: 4,
                    score: 2
                }
            ]
        }
    },
    {
        id: 10002,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'What is your top priority when it comes to maintaining your financial privacy online?',
            answers: [
                {
                    text: 'Keeping my communications with my financial advisor secure',
                    id: 1,
                    score: 0,
                    segment: 'advisor'
                },
                {
                    text: 'Keeping my retirement and investment accounts safe',
                    id: 2,
                    score: 0,
                    segment: 'retirement'
                },
                {
                    text: 'Keeping my everyday checking and savings accounts secure',
                    id: 3,
                    score: 0,
                    segment: 'savings'
                },
                {
                    text: 'I prefer not to manage finances online',
                    id: 4,
                    score: 0,
                    segment: 'peace-of-mind'
                }
            ]
        }
    }
];

export {
    RISK_QUESTION_IDS,
    QUIZ_RISK_SLIDES
};
